var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcTimesBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99267 0.757812C4.43803 0.757812 0.742188 4.45366 0.742188 9.00829C0.742188 13.5629 4.43803 17.2588 8.99267 17.2588C13.5473 17.2588 17.2431 13.5629 17.2431 9.00829C17.2431 4.45366 13.5626 0.757812 8.99267 0.757812ZM12.5352 11.4773C12.8265 11.7687 12.8265 12.2441 12.5352 12.5354C12.3818 12.6888 12.1978 12.7501 11.9984 12.7501C11.7991 12.7501 11.615 12.6735 11.4617 12.5354L8.99267 10.0664L6.52366 12.5354C6.3703 12.6888 6.18628 12.7501 5.98692 12.7501C5.78755 12.7501 5.60353 12.6735 5.45017 12.5354C5.1588 12.2441 5.1588 11.7687 5.45017 11.4773L7.93452 9.00829L5.46551 6.53928C5.17414 6.24791 5.17414 5.77251 5.46551 5.48113C5.75688 5.18976 6.23228 5.18976 6.52366 5.48113L8.99267 7.95014L11.4617 5.48113C11.753 5.18976 12.2284 5.18976 12.5198 5.48113C12.8112 5.77251 12.8112 6.24791 12.5198 6.53928L10.0661 9.00829L12.5352 11.4773Z",
    fill: "#141938"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTimesBlue);
export default __webpack_public_path__ + "static/media/ic_times_blue.4930d41d37dc82d63e03272c9ffd9429.svg";
export { ForwardRef as ReactComponent };